/**
 * Blog listing: custom sort dropdown (accessible listbox). Selecting an option
 * rewrites the `sort` query param and reloads, resetting pagination.
 */
function init($) {
    $('[data-sort-dropdown]').each(function () {
        var $dd      = $(this);
        var $trigger = $dd.find('.blog-sort__trigger');
        var $options = $dd.find('.blog-sort__option');

        function open() {
            $dd.addClass('is-open');
            $trigger.attr('aria-expanded', 'true');
            var $sel = $options.filter('.blog-sort__option--selected');
            ($sel.length ? $sel : $options.first()).trigger('focus');
        }
        function close(focusTrigger) {
            $dd.removeClass('is-open');
            $trigger.attr('aria-expanded', 'false');
            if (focusTrigger) { $trigger.trigger('focus'); }
        }
        function select($opt) {
            var value  = String($opt.data('value'));
            var params = new URLSearchParams(window.location.search);
            params.delete('page');
            if (value === 'recent') { params.delete('sort'); } else { params.set('sort', value); }
            var qs = params.toString();
            window.location.href = window.location.pathname + (qs ? '?' + qs : '');
        }

        $trigger.on('click', function (e) {
            e.stopPropagation();
            if ($dd.hasClass('is-open')) { close(); } else { open(); }
        });

        $options.on('click', function () { select($(this)); });

        $dd.on('keydown', function (e) {
            var $current = $(document.activeElement);
            var idx = $options.index($current);

            if (e.key === 'Escape') {
                close(true);
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!$dd.hasClass('is-open')) { open(); return; }
                $options.eq(Math.min(idx + 1, $options.length - 1)).trigger('focus');
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (idx > 0) { $options.eq(idx - 1).trigger('focus'); }
            } else if ((e.key === 'Enter' || e.key === ' ') && $current.hasClass('blog-sort__option')) {
                e.preventDefault();
                select($current);
            }
        });

        $(document).on('click', function (e) {
            if (!$dd.is(e.target) && $dd.has(e.target).length === 0) { close(); }
        });
    });
}

module.exports = { init };
